import { useEffect, useContext } from 'react';
import { Country, CountryItem, CountriesData } from '../data';
import { CountriesContext } from '../Countries';

export const useSearchTerm = () => {
  const { searchValue, setSearchValue, isSearchActive, setIsSearchActive, foundTerms, setFoundTerms } = useContext(CountriesContext);

  const searchTerm = (sourceArray: Country[], searchValue: string) => {
    let result: any = [];

    if (searchValue === '') {
      result = [];
      return result;
    }

    sourceArray.forEach((item: Country) => {
      if (!item.countries.length) return;
      item.countries.forEach((country: CountryItem) => {
        if (country.name.toLowerCase().includes(searchValue.toLowerCase())) {
          result.push(country);
        }
      });
    });

    return result.length > 0 ? result : [];
  };

  useEffect(() => {
    if (isSearchActive) {
      const result: CountryItem[] = searchTerm(CountriesData, searchValue);
      setFoundTerms(result);
    }
  }, [searchValue, isSearchActive]);

  return {
    searchValue,
    setSearchValue,
    isSearchActive,
    setIsSearchActive,
    foundTerms,
  };
};